/*!
=========================================================
* 区画図画面
=========================================================
*/
import React from "react";

import {
  Col,
  Button,
} from "reactstrap";

import { Link } from 'react-router-dom';
import Request from '../../common/Request';
import InputText from '../FormParts/InputText'
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import WithRole from '../FormParts/ButtonWithRole';
import ListBase from '../Base/SimpleListBaseUnlimit'; // #1168-2021.7.15
import Format from '../../common/Format'
import Definition from '../../common/Definition';
import GsuiteAuth from "../../components/Auth/GsuiteAuth";
// import ListBase from '../Base/ListBase';
import RegistDialog from './RegistDialog';
import { GetMessage, getErrorCodes } from "../../variables/message";
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileLines as faFileLinesSolid, faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons'
import { faFileLines } from '@fortawesome/free-regular-svg-icons'
import 'moment/locale/ja'
import moment from 'moment/moment'

moment.locale('ja')

moment.updateLocale('ja', {
  months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
});

/*
*　クラス名：
*     List   ：検索及び一覧表示用クラス
*/
class List extends ListBase {
  /*
  *　関数・変数名：
  *     default_column    ：ReactTable用のデフォルトカラム設定
  *                         下記のdataMapと連動して使う
  *  KEY 説明：
  *     Header            ：タイトル表示用
  *     accessor          ：dataMap関数とのマッピング用の名称
  *     headerClassName   ：テーブルタイトル（TH）用のCSSクラス名
  *     className         ：テーブルデータ（TD）用のCSSクラス名
  *     width             ：初期表示用横サイズ
  *     min-width         ：リサイズ時の最小サイズ
  * 　　nonTargetFilter   ：表示設定に表示しないように設定する　※省略可　
  *                          true -> しない　false ->　する
  * 　　　　　　　　　　　　　　データの固定列を設定する時に利用 
  */
 
  default_column_1 = [
    { Header: '見積ID\nステータス',accessor: 'BLOCKMAP__estimate_natural_id',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50},
    { Header: '顧客情報',accessor: '___JOIN_client_master',headerClassName:'text-center',className:'text-left text-top',width:300,minWidth:50},
    { Header: '現場名\n工事番号\n現場住所', accessor: '___JOIN_project_information_estimate', headerClassName: "text-center",width:160, className: "text-left text-top" ,defaultView:true},
    { Header: '見積期間/契約期間',accessor: '___JOIN_request_date',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50},
    // { Header: '確定見積期間',accessor: '___JOIN_quote_available_date',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50},
    { Header: '駐車場名',accessor: 'BLOCKMAP__survey_parking_name',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50},
    { Header: '区画図番号',accessor: 'BLOCKMAP__quote_plotting_number',headerClassName:'text-center',className:'text-center text-top',width:100,minWidth:50},
    { Header: 'コメント',accessor: 'BLOCKMAP__plotting_memo',headerClassName:'text-center',className:'text-center text-top',width:150,minWidth:50},
    { Header: '　',accessor: 'actions_1',headerClassName:'text-center',className:'text-center',width:140,minWidth:50, isSortDisabled : true}
  ];

  default_column_2 = [
    { Header: '見積ID\nステータス',accessor: 'BLOCKMAP__estimate_natural_id',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50},
    { Header: '見積期間/契約期間',accessor: '___JOIN_request_date',headerClassName:'text-center',className:'text-left text-top',width:200,minWidth:50},
    { Header: '駐車場名',accessor: 'BLOCKMAP__survey_parking_name',headerClassName:'text-center',className:'text-left text-top',width:150,minWidth:50},
    { Header: '区画図番号',accessor: 'BLOCKMAP__quote_plotting_number',headerClassName:'text-center',className:'text-left text-top',width:100,minWidth:50},
    { Header: '駐車場住所', accessor: '___JOIN_parking_addr', headerClassName: "text-center",width:160, className: "text-left text-top" ,defaultView:true},
    { Header: 'コメント',accessor: 'BLOCKMAP__plotting_memo',headerClassName:'text-center',className:'text-center text-top',width:150,minWidth:50},
    { Header: '　',accessor: 'actions_1',headerClassName:'text-center',className:'text-center',width:140,minWidth:50, isSortDisabled : true},
    { Header: '担当者',accessor: 'BLOCKMAP__blockmap_user_id',headerClassName:'text-center',className:'text-center',width:140,minWidth:50, isSortDisabled : true}
  ];


  /*
  *　関数・変数名：
  *     constructor     　：コンストラクタ関数
  *                         ロード時に1度だけ呼び出される
  *  パラメータ 説明：
  *     props            ：GETやPOSTなどのパラメータ入力値
  */
  constructor(props) {
    console.log(props);

  /*
  *　関数・変数名：
  *     super     　      ：親のコンストラクターを呼び、thisを使えるようにする
  *  パラメータ 説明：
  *     props            ：GETやPOSTなどのパラメータ入力値
  */
    super(props);

  /*
  *　関数・変数名：
  *     Object.assign    ：stateの初期設定
  *  KEY 説明：（※）は必須
  * 
  *     ▼基本設定
  *     title（※）      ：画面タイトル表示名
  *     add_url          ：新規登録画面のURL設定　
  *                        設定されている場合、自動でボタンが表示
  *     search_url（※） ：検索用APIのURL設定　※検索必須
  * 
  *     ▼画面毎設定　※画面定義より自動実装
  *     SUPPLIER__supplier_name    ：仕入先名
  *     SUPPLIER__supplier_tel     ：仕入先TEL
  * 
  *     ▼共通設定
  * 　　column            ：一覧設定用変数
  *                         タイトルやデータの表示形式を設定
  *                         設定内容は、上記「default_column」を参照
  *     detail_search     ：詳細検索表示設定
  *                         true　→　表示する　false  →　表示しない
  *     valid             ：バリデーションの結果設定
  *                         true　→　正常     false   →　エラー
  * 
  */

  Object.assign(this.state, {
      title: '区画図',
      search_url: '/api/blockmap',
      badge:false,
      BLOCKMAP__estimate_natural_id: "",
      BLOCKMAP__survey_parking_name: "",

      column: this.props.box_status == 1 ?this.default_column_1:this.default_column_2,
      detail_search:false,
      valid: true,
      searchData:{
        values:{
        },
        errors:{},
        requiredData:{}
      },
      dialogData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      show_detail_search_field:false,
      auto_scroll:true,
      head_badge_contents: {'区画図UL待ち': null, '区画図依頼中': null},
      badge:true
    });


  /*
  *　関数・変数名：
  *     this.[関数名]    ：this.stateやthis.propsを関数内で利用する場合に設定
  *  構文：
  * 　　this.[関数名] = this.[関数名].bind(this)
  */
    this.validateCallBack = this.validateCallBack.bind(this)
    this.search = this.search.bind(this)
    this.search_count = this.search_count.bind(this)
    this.search_head_badge_count = this.search_head_badge_count.bind(this)
    this.validateCallBackForDialog = this.validateCallBackForDialog.bind(this)

  /*
  *　関数・変数名：
  *     this.[ダイアログ名]    ：ダイアログ利用時に設定をする
  */
    //this.dialogConfirm = React.createRef();
    this.dialog = React.createRef();

  }

  componentDidMount(){
    // this.search_head_badge_count();
    this.search();
  }

  /*
  *　関数・変数名：
  *     dataMap    ：テーブル表示のデータマッピング関数
  *                    
  *  パラメータ 説明：
  *         data   ： JSON形式の実際のデータ
  *  戻り値 説明：
  *         data   ： JSON形式のマッピング済みデータ
  *                   ※タグや、項目連結定義もここでコンバートする
  */
  dataMap(data) {
    // console.log(data,localStorage.id,this.state.blockmap_count );
		let file_icon = (<FontAwesomeIcon icon={faFileLines} />);
		let file_disabled_icon = (<FontAwesomeIcon icon={faFileLinesSolid} style={{color:"gray"}} />);
    console.log(data);
    return data.map((prop, key) => {
      const ButtonWithRole = WithRole(Button, this.props.buttons, prop)
      return {
        id: key,
        BLOCKMAP__estimate_natural_id: <table align="center">
          <tr><td>{prop.estimate_natural_id}</td></tr>
          {this.props.box_status == 1 && prop.latest_pdf_survey_url != null && prop.latest_pdf_survey_url != "" && (<>
            <tr><td><a href={"https://drive.google.com/open?id="+prop.latest_pdf_survey_url} target="_blank">調査見積書確認</a></td></tr>
          </>
          )}
          {this.props.box_status == 1 && prop.latest_pdf_quote_url != null && prop.latest_pdf_quote_url != "" && (<>
          <tr><td><a href={"https://drive.google.com/open?id="+prop.latest_pdf_quote_url} target="_blank">確定見積書確認</a></td></tr>
          </>
          )}
          <tr><td>{prop.latest_pdf_plotting_request_status}</td></tr>
        </table>,
        ___JOIN_client_master: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', prop)}} />,
        ___JOIN_project_information_estimate: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_project_information_estimate', prop)+`<br/>`+Definition.item('___JOIN_project_addr', prop)}} />,
        ___JOIN_request_date: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_request_date', prop)}} />,
        ___JOIN_parking_addr: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_survey_parking_addr', prop)}} />,
        BLOCKMAP__survey_parking_name: <div align="center">{prop.survey_parking_name}</div>,
        BLOCKMAP__quote_plotting_number: <div align="center">{prop.quote_plotting_number}</div>,
        BLOCKMAP__plotting_memo:<div align="center">{prop.plotting_memo}</div>,
        actions_1: <table align="center">
                    <tr><td align="center">
                    {prop.latest_pdf_supplier_plotting_url != null 
                    ? prop.blockmap_user_id != localStorage.id 
                      ? ( <><ButtonWithRole button_id="" size="sm" className={"btn-sm-new"} disabled={true}> 受領区画図<br />のﾀﾞｳﾝﾛｰﾄﾞ</ButtonWithRole></> ) 
                      : ( <> <a href={`/api/gcs_download/${prop.latest_pdf_supplier_plotting_url}?d=受領区画図_${moment().format("YYYYMMDDHHmmss")}&extension=true`} className={"download_btn"} target="_blank"><ButtonWithRole button_id="" size="sm" className={"btn-sm-new"} disabled={false}> 受領区画図<br />のﾀﾞｳﾝﾛｰﾄﾞ</ButtonWithRole></a></>)
                    : ""}
                    </td></tr>
                    <tr><td align="center">
                      <ButtonWithRole
                        button_id=""
                        size="sm"
                        onClick={() => { this.setPropsForDialog(prop); this.dialog.current.show() }}
                        className={"btn-sm-new"}
                        disabled={this.props.box_status == 2 ? prop.blockmap_user_id != localStorage.id : false}
                      >
                        作成した区画図<br />のｱｯﾌﾟﾛｰﾄﾞ
                      </ButtonWithRole>
                    </td></tr>
                  </table>,
        BLOCKMAP__blockmap_user_id:<>{prop.blockmap_user_id != "" && prop.blockmap_user_id != undefined  && prop.blockmap_user_id == localStorage.id  
            ?<ButtonWithRole button_id="" size="sm" onClick={() => { this.setBlockmapUser(prop,0) }} className={"btn-sm-new"} disabled={false}>担当解除</ButtonWithRole>
            : prop.blockmap_user_id != "" && prop.blockmap_user_id != undefined && prop.blockmap_user_id != localStorage.id 
              ?<div>担当割当済</div>
              :<ButtonWithRole button_id="" size="sm" onClick={() => { this.setBlockmapUser(prop,localStorage.id) }} className={"btn-sm-new"} disabled={this.state.blockmap_count>=3}>担当する</ButtonWithRole>
      }</>
      }
    });
  }

  /*
  *　関数・変数名：
  *     search_params    ：検索用パラメータ確認と設定
  *                        データ自体は、Stateより取得
  *   
  *  戻り値 説明：
  *     KEY     ：カラム名
  *     VALUE   ：検索値
  */
  search_params() {
    const {values} = this.state.searchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]
      }
      return acc
    },{})
  }

  /*
  *　関数・変数名：
  *     search    ：検索実行関数（APIへのリクエストを担当）
  *   
  */
  search() {
    /* ここは開発者が記述 */
    if (!this.validate()) {
        // do nothing
        return;
    }
    this.search_count();
    this.blockmap_user_count();
    var searchParams = this.search_params()
    searchParams["pager_index"] = "0";
    searchParams["pager_limit"] = this.state.paging["limit"];
    searchParams["latest_pdf_plotting_request_status"] = this.props.box_status;
    Request.get(this.state.search_url, 
      searchParams
      , res => {
        this.setState({
          paging: {
            "index": parseInt(searchParams["pager_index"]),
            "limit": parseInt(searchParams["pager_limit"])
          },  
          data: this.dataMap(res.Data)
        });
    })
  }
  /* #1168-2021.7.15 データ件数の取得 */
  search_count() {
    var search_param = this.search_params();
    search_param["data_count"] = 1;
    search_param["latest_pdf_plotting_request_status"] = this.props.box_status;
    Request.get(this.state.search_url, search_param, res => {
        this.setState({data_count: res.Data});
    })
  }

  search_head_badge_count() {
    Request.get('/api/blockmap/responsible_counts', {"user_id": GsuiteAuth.get('id')}, res => {
      this.setState({
        head_badge_contents: {
          '区画図UL待ち': res.Data["upload_pending"],
          '区画図依頼中': res.Data["in_order"]
        }
      })
    })
  }

  /*
  *　関数・変数名：
  *     validate    ：バリデーションのエラー判定用関数
  *                   エラーがあるか無いかの判定のみ
  *                   バリデーションのチェックは、フォームのコンポーネント側に実装 
  */
  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  /*
  *　関数・変数名：
  *     handle_[定義名]    ：Inputフォームのイベントを受け取るための関数
  *                         専用コンポーネント（InputTelやInputNumberなど）がない場合に記述する
  *  パラメータ 説明：
  *         e        ：イベント 
  * 
  */
  validateCallBack(newData, callback=()=>{}){
    this.setState({
      searchData:{
        ...this.state.searchData,
        ...newData
      }
    }, ()=>callback())
  }

  /*
  *　関数・変数名：
  *     search_field_cols   ：検索フォーム用フィールドを表示するための関数
  */
  search_field_cols() {
    return (
      <>
        <Col md="4">
          <InputText label="見積ID"
                     name="BLOCKMAP__estimate_natural_id"
                     labelOn={true} 
                     validateCallback={this.validateCallBack} 
                     enterCallback={this.searchWithPageIndex}
                     rootData={this.state.searchData}
                     validateType={"search"}
                     enterSearchFlag={true} />
        </Col>
        <Col md="4">
          <InputText label="駐車場名" 
                     name="BLOCKMAP__survey_parking_name" 
                     labelOn={true} 
                     validateCallback={this.validateCallBack} 
                     validateType={"search"} 
                     enterCallback={this.searchWithPageIndex} 
                     rootData={this.state.searchData}
                     enterSearchFlag={true} />
        </Col>
      </>
    );
  }

  /*
  *　関数・変数名：
  *     add_field_cols   ：新規登録ボタン以外を表示するための関数
  *                        表示箇所は、新規登録ボタンの直後
  *                        ※新規登録ボタンは、add_urlを記述で自動表示
  *                        ※省略可
  */
  add_field_cols() {
    const ButtonWithTooltipWithRole = WithRole(ButtonWithTooltip, this.props.buttons)
    return (<></>);
  }

  /*
  *　関数・変数名：
  *     detail_search_field_btn   ：詳細検索用ボタンを表示するための関数
  *                                 ※省略可
  */
  detail_search_field_btn(){
      return (<></>);
  }

  /*
  *　関数・変数名：
  *     detail_search_field_cols   ：詳細検索用フィールドを表示するための関数
  *                                  ※省略可
  */
  detail_search_field_cols(){
      return (<></>);
  }

  /*
  *　関数・変数名：
  *     checkbox_field_cols   ：一覧の下にSELECTやCheckboxを表示するための関数
  *                             ※省略可
  */
  checkbox_field_cols(){
    return (
      <></>
    );
  }  

  // 0は解除
  async setBlockmapUser(estimateData,user=0){
    const file_upload = await new Promise((resolve, reject) => {

      const url = '/api/blockmap/' + estimateData.ulid
      const uploadParams = {
          blockmap_user_id: user,
          update_timestamp: estimateData.update_timestamp
      }

      Request.put(url, uploadParams, res => {
          // console.log(res.Data)
          this.setState({
            blockmap_count:res.Data.count
          });
          resolve(res)
      }, err => reject(err));
   })
   this.props.alertModal.current.confirmCheck({
    title: "処理完了",
    messageNo: 2417,
    closeBtn: false
    }, () => {
        // this.toggleModal()
        this.search()
    }, false)
    }
  
  // 担当数をカウント
  blockmap_user_count(){
    Request.get('/api/blockmap/user_count',
      { blockmap_user_id:localStorage.id },
      res => {
        // console.log(res)
        this.setState({
          blockmap_count:res.Data.count
        });
      }
    )
  }

  setPropsForDialog(props){
    const {
      project_natural_id
    } = props;
//    console.log("setPropsForDialog",props);
    Request.get('/api/construction/report',
      { project_natural_id },
      res => {
        let assignment = {
          send_destination_type:(res.Data[0].send_destination_type)? res.Data[0].send_destination_type: "",
          customer_user_email:(res.Data[0].customer_user_email)? res.Data[0].customer_user_email: "",
          subcontract_customer_user_email:(res.Data[0].subcontract_customer_user_email)? res.Data[0].subcontract_customer_user_email: "",
        }
/*
        const {
          send_destination_type
        } = res.Data[0]
*/
//        console.log(res.Data[0]);

        this.setState({
          dialogData:{
            values: Object.assign(props, assignment),
            errors:{},
            requiredData:{}
          }
        })
      }
    )
  }

  validateCallBackForDialog(newData, callback=()=>{}){
    const { quote_plotting_number,quote_plotting_picture_url } = newData.values;
    let requiredData = {}
    // if(quote_plotting_number === undefined || quote_plotting_number === null || quote_plotting_number === ""){
    //   requiredData["quote_plotting_number"] = [GetMessage(2024)];
    // }
    if(quote_plotting_picture_url === undefined || quote_plotting_picture_url === null || quote_plotting_picture_url === ""){
      requiredData["quote_plotting_picture_url"] = [GetMessage(2024)];
    }
    
    this.setState({
      dialogData:{
        ...this.state.dialogData,
        ...newData,
        errors : {
          ...newData.errors,
          ...requiredData,
        }
      }
    }, ()=>callback())
  }

  /*
  *　関数・変数名：
  *     dialog_defines        ：ダイアログを表示設定をするための関数
  *                             ※省略可
  * 設定方法：
  *   1）ダイアログ用コンポーネントを設定
  * 　  ※ソースの最上部、import区に追加
  *     import DialogBase from '../Base/DialogBase';
  *   2）コンストラクタへ追加
  *   ※this.[任意のダイアログ名] = React.createRef();
  * 　  this.dialogConfirm = React.createRef();
  *   3）dialog_defines内でダイアログを呼び出す
  *     <DialogConfirm ref={this.dialogConfirm} />
  * 
  *   ※パラメータの設定方法
  *     スペースを開けて、追記していく
  *     <DialogConfirm ref={this.dialogConfirm} title={this.state.title} default_footer={true} />
  * 　　その他、設定パラメータ
  *          title　:　ダイアログタイトル
  *          size   : ダイアログサイズ
  *          default_footer   ： 初期フッターの表示有無
  *          positive         ：「はい」「OK」などの表示有無
  *          newtral          ：「はい」「いいえ」などの 間に表示するボタンの表示有無 
  *          negative         ：「いいえ」「キャンセル」などの表示有無
  *          class            ：CSS用Class設定
  *          positive_label   ：ラベル　初期は「はい」
  *          newtral_label    ：ラベル　初期は「キャンセル」
  *          negative_label   ：ラベル　初期は「いいえ」
  */
  dialog_defines() {
    return (
      <>
        <RegistDialog ref={this.dialog} 
          validateCallBackForDialog = {this.validateCallBackForDialog}
          data={this.state.dialogData}
          updatePlottingDrawing = {this.updatePlottingDrawing}
          positive={true}
          positive_label="保存"
          negative_label="キャンセル"
          refreshCallback={this.search}
          plotting_number_flag={this.props.box_status==1}
          {...this.props}
        />
      </>
    );
  } 

}

export default List;
  /*
  *　クラス名：
  *     DialogConfirm   ：クラス名自体はダイアログの任意の名前
  */
/*  
 class DialogConfirm extends DialogBase {
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: 'タイトル',
    });
  }

  /*
  *　クラス名：
  *     componentDidUpdate   ：propsの値をチェックするための関数
  *                            変更されたら、Stateに設定する。
  * 詳細は下記URLチェック
  * https://ja.reactjs.org/docs/react-component.html#componentdidupdate
  *
  */
/*
  componentDidUpdate(prevProps) {
    if (prevProps.title !== this.props.title){
      this.setState({title:this.props.title});
    }
  }

  bodyContent() {
    return (
      <>
      <textarea style={{width: "100%"}} name="example" rows="5" placeholder="差戻メッセージを入力してください。"></textarea>
      </>
    );
  }
}


*/